import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  AlertConfirmService,
  AlertConfirmState
} from '../../services/alert-confirm.service';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-alert-confirm',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './alert-confirm.component.html',
  styleUrls: ['./alert-confirm.component.scss']
})
export class AlertConfirmComponent {

  state$: Observable<AlertConfirmState>;

  constructor(
    public alertService: AlertConfirmService
  ) {
    this.state$ = this.alertService.modalState$;
  }
}